import styles from './index.module.scss'
import clsx from 'clsx'

type BoxShadowClassModifier = 0 | 100 | 200 | 300 | 400 | 500

export interface BoxShadowProps {
  /**
   * Box Shadow - Add or remove shadows to elements with box-shadow utilities. The helpers allow you to control relative depth, or distance, between two surfaces.
   */
  boxShadow?: BoxShadowClassModifier
}

export const boxShadow = (props: BoxShadowProps) => {
  const boxShadow = getBoxShadowClasses('box-shadow', props?.boxShadow)

  return clsx(boxShadow)
}

const getBoxShadowClasses = (
  classPrefix: string,
  classModifier?: BoxShadowClassModifier
) => {
  if (classPrefix && (classModifier === 0 || classModifier)) {
    return styles[`${classPrefix}-${classModifier}`]
  }
}
